import { s } from "redom"

export const countriesTabs = [
    'eventodeportivo_paises_tabs_texto_tab1',
    'eventodeportivo_paises_tabs_texto_tab2' 
]

export const lettersTabs = {
    a: 'eventodeportivo_paises_tabs1_texto_tab2',
    b: 'eventodeportivo_paises_tabs1_texto_tab3',
    c: 'eventodeportivo_paises_tabs1_texto_tab4',
    e: 'eventodeportivo_paises_tabs1_texto_tab5',
    f: 'eventodeportivo_paises_tabs1_texto_tab6',
    g: 'eventodeportivo_paises_tabs1_texto_tab7',
    h: 'eventodeportivo_paises_tabs1_texto_tab8',
    i: 'eventodeportivo_paises_tabs1_texto_tab9',
    j: 'eventodeportivo_paises_tabs1_texto_tab10',
    m: 'eventodeportivo_paises_tabs1_texto_tab11',
    n: 'eventodeportivo_paises_tabs1_texto_tab12',
    p: 'eventodeportivo_paises_tabs1_texto_tab13',
    s: 'eventodeportivo_paises_tabs1_texto_tab14',
    t: 'eventodeportivo_paises_tabs1_texto_tab15',
    u: 'eventodeportivo_paises_tabs1_texto_tab16',
    r: 'eventodeportivo_paises_tabs1_texto_tab17'
}

export const STAR_FILLED = 'eventodeportivo_icono_agregarfavorito'
export const STAR_EMPTY  = 'eventodeportivo_icono_quitarfavorito'


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/constants.js